import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["fill"];
import React from 'react';
var SVG_PATHS = [{
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z'
}, {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9 11.5C10.3807 11.5 11.5 10.3807 11.5 9C11.5 7.61929 10.3807 6.5 9 6.5C7.61929 6.5 6.5 7.61929 6.5 9C6.5 10.3807 7.61929 11.5 9 11.5ZM9 13.5C11.4853 13.5 13.5 11.4853 13.5 9C13.5 6.51472 11.4853 4.5 9 4.5C6.51472 4.5 4.5 6.51472 4.5 9C4.5 11.4853 6.51472 13.5 9 13.5Z'
}];
export var DEFAULT_FILL_EXCEEDS_MASTERY = '#0374B5';
export var ExceedsMasteryIcon = function ExceedsMasteryIcon(_ref) {
  var _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? DEFAULT_FILL_EXCEEDS_MASTERY : _ref$fill,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    id: "exceeds-mastery",
    width: "18",
    height: "18",
    viewBox: "-1 -1 20 20",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Exceeds Mastery"
  }, props), SVG_PATHS.map(function (pathProps, index) {
    return /*#__PURE__*/React.createElement("path", Object.assign({
      key: index
    }, pathProps));
  }));
};
export var exceedsMasteryIconSvgPaths = SVG_PATHS.map(function (p) {
  return "<path fill-rule=\"".concat(p.fillRule, "\" d=\"").concat(p.d, "\"/>");
}).join('');